import BaseScene from './BaseScene';
import ButtonSprite from '../components/ButtonSprite';
import SliderButtonHorizontal from '../components/SliderButtonHorizontal';
import translate from '../components/LanguageManager';

interface GameData {
    score: number;
    levelId: number;
}

export default class GameLosed extends BaseScene {

    private gameSpeed = 0;
    private speedSliderBar?: SliderButtonHorizontal;

    constructor() {
        super({key: 'GameLosed'});
    }

    public init(data: GameData) {
        super.init();

        this.data.set('score', data.score);
        this.data.set('levelId', data.levelId);
        this.gameSpeed = this.getBootloaderScene().AppData.settings.gameSpeed;
    }

    public create() {
        super.create();

        // Music
        this.getBootloaderScene().soundManager.playLoseMusic();

        // BG
        this.add.rectangle(this.width / 2, this.height / 2, 2000, 2000, parseInt('000000', 16)).setAlpha(0.7);
        
        // Panel
        const panel = this.add.image(0, 0,'game_panel_main_medium_02');

        const title = this.add.text(0, -215, translate.key('game_losed_title'))
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 50,
                color: '#fff'
            })
            .setStroke('#212121', 6);

        const description = this.add.text(0, -60, this.getRandomMessage())
            .setOrigin(0.5)
            .setWordWrapWidth(240)
            .setStyle({ 
                fontFamily: 'supersonic',
                fontSize: 24,
                color: '#3d3d3d',
                align: 'center'
            });

        const speedDescription = this.add.text(0, 168, translate.key('settings_text_2'))
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 18,
                color: '#ece9e7'
            });

        const replayButton = new ButtonSprite(this, -95, 100, 'button_replay', 2, () => this.replayGame());

        const menuButton = new ButtonSprite(this, 95, 100, 'button_menu', 2, () => this.exitToMenu());

        const container = this.add.container(this.width / 2, -300).add([panel, title, description, speedDescription, replayButton, menuButton]);

        // Speed Slider Bar
        this.speedSliderBar = new SliderButtonHorizontal(
            this,
            this.width / 2,
            -180,
            this.gameSpeed,
            this.setGameSpeedPercentage.bind(this),
            'slide_button_selector',
            0.5,
            0.4
        );

        // Tween
        this.tweens.add({
            y: 460,
            targets: container,
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });

        this.speedSliderBar.applyTweens({
            y: 660,
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });

    }

    private getRandomMessage(): string {
        const messages = [
            translate.key('game_losed_text_1'),
            translate.key('game_losed_text_2'),
            translate.key('game_losed_text_3'),
            translate.key('game_losed_text_4'),
            translate.key('game_losed_text_5'),
            translate.key('game_losed_text_6'),
            translate.key('game_losed_text_7'),
            translate.key('game_losed_text_8'),
            translate.key('game_losed_text_9'),
            translate.key('game_losed_text_10'),
            translate.key('game_losed_text_11'),
            translate.key('game_losed_text_12'),
        ];
        const randomIndex = Math.floor(Math.random() * messages.length);
        return messages[randomIndex];
    }

    private replayGame() {
        this.getBootloaderScene().setGameSpeed(this.gameSpeed);
        this.getBootloaderScene().launchScene('GameLevel');
    }

    private exitToMenu() {
        this.getBootloaderScene().setGameSpeed(this.gameSpeed);
        this.getBootloaderScene().launchScene('MainMenu');
    }

    private setGameSpeedPercentage(barPercentage: number): void {
        this.gameSpeed = barPercentage;
    }

    public update(): void {
        // Slider Button
        this.speedSliderBar?.update();
    }
}